export default "__VITE_ASSET__laD4af3s__"